<template>
    <div>
        <div class="card card-default">
            <div class="card-header">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>
                        API Requests
                    </span>
                </div>
            </div>

            <div class="card-body text-center">
                <i v-if="loading" class="fa fa-spinner fa-spin" style="margin:0 auto"></i>
                <div v-else>
                    <p class="alert alert-default mb-0" v-if="requests.length === 0">
                        No requests to show
                    </p>
                    <pagination :data="pagination" v-on:pagination-change-page="fetchRequests"></pagination>

                    <table class="table mb-0" v-if="requests.length > 0">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Time</th>
                                <th>IP</th>
                                <th>Method</th>
                                <th>Route</th>
                                <th>Response Code</th>
                                <th>Data</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="request in requests" :key="request.id">
                                <td>
                                    {{ request.id }}
                                </td>
                                <td>
                                    {{ request.time }}
                                </td>
                                <td>
                                    {{ request.ip }}
                                </td>
                                <td>
                                    {{ request.method }}
                                </td>
                                <td>
                                    {{ request.route }}
                                </td>
                                <td>
                                    {{ request.response_status }}
                                </td>
                                <td>
                                    <button @click="show(request)" class="btn btn-sm btn-info">Show more</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div><!-- /card-body -->
        </div><!-- /card -->
        <modal v-if="showing" @cancel="show(null)">
            <h5 class="modal-title" slot="title">
                {{ showing.method }}: {{ showing.route }}
            </h5>
            
            <div class="modal-body">
                <div class="card">
                    <h6 class="card-header">Request headers</h6>
                    <pre class="card-body">{{ JSON.stringify(showing.headers, null, 2) }}</pre>
                </div>

                <div class="card mt-2">
                    <h6 class="card-header">Request body</h6>
                    <pre class="card-body">{{ JSON.stringify(showing.payload, null, 2) }}</pre>
                </div>

                <div class="card mt-2">
                    <h6 class="card-header">Response body</h6>
                    <pre class="card-body">{{ JSON.stringify(showing.response, null, 2) }}</pre>
                </div>
            </div>

            <div class="modal-footer">
                <button @click="show(null)" class="btn btn-default">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
    import Modal from '../utils/Modal_v2';

    export default {
        components: {
            Modal
        },
        /*
         * The component's data.
         */
        data() {
            return {
                showing: null,
                loading: true,
                requests: [],
                pagination: {}
            };
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            moment(optional) {
                if (optional) {
                    return moment(optional);
                }

                return moment();
            },

            /**
             * Prepare the component.
             */
            prepareComponent() {
                this.fetchRequests();
            },

            /**
             * Get all of the API requests for this user
             */
            fetchRequests(page) {
                this.loading = true;
                axios.get('/settings/api/requests?page='+page, {
                    accept: 'application/json'
                })
                     .then(response => {
                        this.requests = response.data.data;
                        this.loading = false;

						this.pagination.current_page = response.data.meta.pagination.current_page;
                        this.pagination.last_page = response.data.meta.pagination.total_pages;
                        this.pagination.next_page_url = response.data.meta.pagination.links.next;
                        this.pagination.per_page = response.data.meta.pagination.per_page;
                        this.pagination.prev_page_url = response.data.meta.pagination.links.previous;
                        this.pagination.total = response.data.meta.pagination.total;
                });
            },

            /**
             * Shows the selected request details
             */
            show(request) {
                this.showing = request;
            }
        }
    }
</script>
